import React from "react";
import { Briefcase, Wrench } from "lucide-react";
import { PROJECTS, TOOLS } from "@/data/certificationProgramData";

const DIFFICULTY_COLOR = {
  Beginner: "text-emerald-300 border-emerald-400/30 bg-emerald-400/10",
  Intermediate: "text-amber-300 border-amber-400/30 bg-amber-400/10",
  Advanced: "text-red-300 border-red-400/30 bg-red-400/10",
};

export function ProjectsSection() {
  return (
    <div className="mb-10" data-testid="certification-projects-section">
      <h2 className="font-heading text-2xl font-semibold text-white mb-1 flex items-center gap-2"><Briefcase className="w-5 h-5 text-amber-300" /> 5 enterprise projects. 5 industries.</h2>
      <p className="text-sm text-slate-400 mb-5">Every project mirrors a genuine Data Cloud consulting engagement — built for your portfolio, not a demo reel.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-testid="certification-projects-grid">
        {PROJECTS.map((p, i) => (
          <div key={i} className="glass-panel rounded-2xl p-6 flex flex-col" data-testid={`certification-project-${i}`}>
            <div className="flex items-center justify-between mb-2">
              <span className="text-[11px] font-bold uppercase tracking-wide text-amber-300">0{i + 1} · {p.industry}</span>
              <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${DIFFICULTY_COLOR[p.difficulty]}`}>{p.difficulty}</span>
            </div>
            <h3 className="text-base font-semibold text-white mb-2">{p.title}</h3>
            <p className="text-xs text-slate-400 mb-2"><span className="font-semibold text-slate-300">Problem:</span> {p.problem}</p>
            <p className="text-xs text-slate-400 mb-3"><span className="font-semibold text-slate-300">Solution:</span> {p.solution}</p>
            <div className="flex flex-wrap gap-1.5 mb-3">
              {p.components.map((c, j) => <span key={j} className="text-[10px] font-medium text-slate-300 bg-white/5 border border-white/10 rounded-full px-2 py-0.5">{c}</span>)}
            </div>
            <div className="mt-auto pt-3 border-t border-white/5 flex items-center justify-between text-[11px] text-slate-500">
              <span>Skills: {p.skills.slice(0, 2).join(", ")}...</span>
              <span className="font-semibold text-slate-400">{p.duration}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function TimelineSection() {
  return (
    <div className="mb-10" data-testid="certification-timeline-section">
      <h2 className="font-heading text-xl font-semibold text-white mb-5">The order you'll build them in.</h2>
      <div className="flex flex-col sm:flex-row gap-3" data-testid="certification-timeline-list">
        {PROJECTS.map((p, i) => (
          <div key={i} className="glass-panel rounded-xl p-4 flex-1 flex items-center gap-3" data-testid={`certification-timeline-${i}`}>
            <span className="w-7 h-7 rounded-full bg-amber-400/15 border border-amber-400/30 text-amber-300 text-xs font-bold flex items-center justify-center shrink-0">{i + 1}</span>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-wide text-slate-500">{p.industry}</p>
              <p className="text-xs font-semibold text-white leading-tight">{p.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ToolsSection() {
  return (
    <div className="mb-10" data-testid="certification-tools-section">
      <h2 className="font-heading text-xl font-semibold text-white mb-1 flex items-center gap-2"><Wrench className="w-4.5 h-4.5 text-amber-300" /> The exact Data Cloud toolset employers expect.</h2>
      <div className="flex flex-wrap gap-2 mt-4" data-testid="certification-tools-grid">
        {TOOLS.map((t, i) => (
          <span key={i} className="text-xs font-medium text-slate-300 bg-white/5 border border-white/10 rounded-full px-3.5 py-1.5" data-testid={`certification-tool-${i}`}>{t}</span>
        ))}
      </div>
    </div>
  );
}
